/**
 * Posh Cave Shopify Theme JavaScript
 * Handles cart, navigation, and interactive elements
 */

// Cart Drawer Functions
function openCartDrawer() {
  const drawer = document.getElementById('cart-drawer');
  if (drawer) {
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
}

function closeCartDrawer() {
  const drawer = document.getElementById('cart-drawer');
  if (drawer) {
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
}

// Update cart quantity
function updateCartQuantity(line, quantity) {
  if (quantity < 0) return;
  
  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      line: line,
      quantity: quantity
    })
  })
  .then(response => response.json())
  .then(data => {
    // Reload cart contents
    fetch('/cart?view=drawer')
      .then(response => response.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newCartItems = doc.querySelector('#cart-items');
        const currentCartItems = document.querySelector('#cart-items');
        
        if (newCartItems && currentCartItems) {
          currentCartItems.innerHTML = newCartItems.innerHTML;
        }
        
        // Update cart count
        updateCartCount(data.item_count);
      });
  })
  .catch(error => {
    console.error('Error updating cart:', error);
  });
}

// Remove cart item
function removeCartItem(line) {
  updateCartQuantity(line, 0);
}

// Update cart count in nav
function updateCartCount(count) {
  // Update desktop cart badge
  const desktopBadge = document.getElementById('desktop-cart-count');
  if (desktopBadge) {
    desktopBadge.textContent = count;
    desktopBadge.style.display = count > 0 ? 'flex' : 'none';
  }
  
  // Update mobile cart text
  const mobileCartText = document.getElementById('mobile-cart-text');
  if (mobileCartText) {
    mobileCartText.textContent = count > 0 ? `Cart (${count})` : 'Cart';
  }
  
  // Trigger a small animation on the cart icon
  const desktopCartLink = document.getElementById('desktop-cart-link');
  if (desktopCartLink) {
    desktopCartLink.style.transform = 'scale(1.2)';
    setTimeout(() => {
      desktopCartLink.style.transform = 'scale(1)';
    }, 200);
  }
}

// Mobile Menu Toggle
function toggleMobileMenu() {
  const mobileMenu = document.getElementById('mobile-menu');
  const menuIconOpen = document.getElementById('menu-icon-open');
  const menuIconClose = document.getElementById('menu-icon-close');
  
  if (mobileMenu) {
    const isHidden = mobileMenu.style.display === 'none' || !mobileMenu.style.display;
    mobileMenu.style.display = isHidden ? 'block' : 'none';
    
    if (menuIconOpen && menuIconClose) {
      menuIconOpen.style.display = isHidden ? 'none' : 'block';
      menuIconClose.style.display = isHidden ? 'block' : 'none';
    }
  }
}

// Mobile Mega Menu Toggle
function toggleMobileMegaMenu() {
  const mobileMegaMenu = document.getElementById('mobile-mega-menu');
  const arrow = document.getElementById('mobile-mega-arrow');
  
  if (mobileMegaMenu) {
    const isHidden = mobileMegaMenu.style.display === 'none' || !mobileMegaMenu.style.display;
    mobileMegaMenu.style.display = isHidden ? 'block' : 'none';
    
    if (arrow) {
      arrow.style.transform = isHidden ? 'rotate(180deg)' : 'rotate(0deg)';
    }
  }
}

// Desktop Mega Menu
document.addEventListener('DOMContentLoaded', function() {
  const megaMenuTriggers = document.querySelectorAll('.mega-menu-trigger');
  
  megaMenuTriggers.forEach(trigger => {
    let timeout;
    const megaMenu = trigger.querySelector('.mega-menu');
    const arrow = trigger.querySelector('.mega-menu-arrow');
    
    if (!megaMenu) return;
    
    trigger.addEventListener('mouseenter', () => {
      clearTimeout(timeout);
      megaMenu.style.display = 'block';
      if (arrow) arrow.style.transform = 'rotate(180deg)';
    });
    
    trigger.addEventListener('mouseleave', () => {
      timeout = setTimeout(() => {
        megaMenu.style.display = 'none';
        if (arrow) arrow.style.transform = 'rotate(0deg)';
      }, 300);
    });
  });
});

// Product Image Gallery
function changeMainImage(src, button) {
  const mainImage = document.getElementById('main-product-image');
  if (mainImage) {
    mainImage.src = src;
  }
  
  // Update active thumbnail
  const thumbnails = button.parentElement.querySelectorAll('button');
  thumbnails.forEach(thumb => {
    thumb.classList.remove('border-[#C7A375]');
    thumb.classList.add('border-transparent');
  });
  button.classList.remove('border-transparent');
  button.classList.add('border-[#C7A375]');
}

// Show Affiliate Info Modal
function showAffiliateInfo() {
  const modal = document.getElementById('affiliate-modal');
  if (modal) {
    modal.style.display = 'flex';
  }
}

// Product Tabs
document.addEventListener('DOMContentLoaded', function() {
  const tabButtons = document.querySelectorAll('.tab-button');
  const tabContents = document.querySelectorAll('.tab-content');
  
  tabButtons.forEach(button => {
    button.addEventListener('click', () => {
      const targetTab = button.getAttribute('data-tab');
      
      // Remove active class from all buttons and contents
      tabButtons.forEach(btn => btn.classList.remove('active'));
      tabContents.forEach(content => content.classList.remove('active'));
      
      // Add active class to clicked button and corresponding content
      button.classList.add('active');
      const targetContent = document.getElementById(targetTab);
      if (targetContent) {
        targetContent.classList.add('active');
      }
    });
  });
});

// Add to Cart
function addToCart(variantId, quantity = 1) {
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      id: variantId,
      quantity: quantity
    })
  })
  .then(response => response.json())
  .then(data => {
    // Update cart
    return fetch('/cart.js');
  })
  .then(response => response.json())
  .then(cart => {
    updateCartCount(cart.item_count);
    openCartDrawer();
  })
  .catch(error => {
    console.error('Error adding to cart:', error);
    alert('Sorry, there was an error adding the item to your cart. Please try again.');
  });
}

// Cart page quantity update
function updateCart(input, line) {
  const quantity = parseInt(input.value);
  
  if (isNaN(quantity) || quantity < 0) {
    input.value = 0;
    return;
  }
  
  // Redirect to cart change URL
  window.location.href = `/cart/change?line=${line}&quantity=${quantity}`;
}

// Scroll detection for navbar (homepage only)
if (window.location.pathname === '/') {
  let ticking = false;
  
  function updateNavbar() {
    const scrollY = window.scrollY;
    const navContainer = document.getElementById('nav-container');
    
    if (!navContainer) return;
    
    // Check sections to determine if nav is over dark or light background
    const sections = document.querySelectorAll('section, div[class*="bg-"]');
    let isDark = true; // Default to dark (for hero)
    
    sections.forEach((section) => {
      const rect = section.getBoundingClientRect();
      const navbarHeight = 100;
      
      if (rect.top <= navbarHeight && rect.bottom >= navbarHeight) {
        const bgClasses = section.className;
        
        // Check if section has light background
        if (
          bgClasses.includes('bg-white') ||
          bgClasses.includes('bg-[#F8F6F2]') ||
          bgClasses.includes('bg-[#F7F4EF]') ||
          bgClasses.includes('bg-gradient-to-br from-[#F8F6F2]') ||
          bgClasses.includes('bg-gradient-to-br from-[#EDE3D8]')
        ) {
          isDark = false;
        }
      }
    });
    
    // Update nav styles
    if (isDark) {
      navContainer.className = 'rounded-[40px] px-6 py-3 transition-all duration-500 bg-white/10 backdrop-blur-lg shadow-md border border-white/20';
    } else {
      navContainer.className = 'rounded-[40px] px-6 py-3 transition-all duration-500 bg-white/95 backdrop-blur-xl shadow-xl border border-gray-200/50';
    }
    
    ticking = false;
  }
  
  function requestTick() {
    if (!ticking) {
      window.requestAnimationFrame(updateNavbar);
      ticking = true;
    }
  }
  
  window.addEventListener('scroll', requestTick);
  updateNavbar(); // Initial call
}

// Search functionality (basic)
function handleSearch(event) {
  event.preventDefault();
  const searchInput = event.target.querySelector('input[name="q"]');
  if (searchInput && searchInput.value.trim()) {
    window.location.href = `/search?q=${encodeURIComponent(searchInput.value.trim())}`;
  }
}

// Console log to confirm script loaded
console.log('Posh Cave theme script loaded successfully');

